module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function (fox, $) {
	'use strict';

	fox.registerWidget('PersonalData', {

		configure: function (options) {
			
			this.registerOptions('', {
				autoRender: true,
				'embed.container': '#user-personal-data',
                template: 'user_personal_data',
                widgets: {
                    updateApi: {
                        widget: 'Api',
                        method: 'consent.provideBulk',
                        httpMethod: 'post'
                    },
                    getSettingsApi: {
                        widget: 'Api',
                        method: 'consent.list'
                    },
                },
                handleDom: {
                    required: {
                        target: '.required-checkbox',
                        callback: '_showAttentionPopup'
                    },
                    change: {
                        target: '.communication-checkbox',
                        event: 'change',
                        callback: '_change'
                    }
                }
			});

			this.callParent('configure', arguments);
		},

		running: function() {  
            // var deleteAccount =  fox.site.wom1('#gdprDeleteAccount');
            // var deleteAccountConfirm = deleteAccount.wom1('#GDPR_AccountDeleteConfirm');
            this.getSettings().then(this._renderData.bind(this));
            this.callParent('running', arguments);
        },

        activate: function() {
            this.getSettings().then(this._renderData.bind(this));
            this.callParent('activate', arguments);
        },

		getSettings: function() {
            return this.wom1('#getSettingsApi').psend({});
        },
        
        _renderData: function(resp) {
            var data = resp.params.answer.response;

            data.timestamp *= 1000;
            
            this.setTemplateOptions(fox.merge(data, {modelName: fox.site.getEnv('screenName')})).render();
        },

        _showAttentionPopup: function(elm) {
            this.showAttentionPopup().then(function(result) {
                if (result === true) {
                    return;
                }
            });
        },

        showAttentionPopup: function() {

            return fox.site.rwom1('#gdprAttentionActions').show()
        },

        _change: function(elm) {
            // var elms = this.dom('#marketing');
            var data = {};

            // fox.each(elms, function(elm) {
                
            // });

            data[elm.name] = Number(elm.checked);

            return this.wom1('#updateApi')
                .psend({aliases: data});
        }

	}, 'Widget');

})(fox, fox.jQuery);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/common-components/GDPR/widget/personalData.js
// module id = 618
// module chunks = 2